module.exports = __webpack_public_path__ + "img/e47b7ac.jpg";